module.exports = __webpack_public_path__ + "img/cooperative0_logo14.400598f3.jpg";